export const HIERARCHICAL_DEPARTMENTS_NEW_LOAD = 'HIERARCHICAL_DEPARTMENTS_NEW_LOAD'
export const HIERARCHICAL_DEPARTMENTS_NEW_LOAD_PENDING = 'HIERARCHICAL_DEPARTMENTS_NEW_LOAD_PENDING'
export const HIERARCHICAL_DEPARTMENTS_NEW_LOAD_FULFILLED =
  'HIERARCHICAL_DEPARTMENTS_NEW_LOAD_FULFILLED'
export const HIERARCHICAL_DEPARTMENTS_NEW_LOAD_REJECTED =
  'HIERARCHICAL_DEPARTMENTS_NEW_LOAD_REJECTED'

export const LIST_DEPARTMENTS_LOAD = 'LIST_DEPARTMENTS_LOAD'
export const LIST_DEPARTMENTS_LOAD_PENDING = 'LIST_DEPARTMENTS_LOAD_PENDING'
export const LIST_DEPARTMENTS_LOAD_FULFILLED = 'LIST_DEPARTMENTS_LOAD_FULFILLED'
export const LIST_DEPARTMENTS_LOAD_REJECTED = 'LIST_DEPARTMENTS_LOAD_REJECTED'

export const DEPARTMENTS_POST = 'DEPARTMENTS_POST'
export const DEPARTMENTS_POST_PENDING = 'DEPARTMENTS_POST_PENDING'
export const DEPARTMENTS_POST_FULFILLED = 'DEPARTMENTS_POST_FULFILLED'
export const DEPARTMENTS_POST_REJECTED = 'DEPARTMENTS_POST_REJECTED'

export const DEPARTMENTS_PUT = 'DEPARTMENTS_PUT'
export const DEPARTMENTS_PUT_PENDING = 'DEPARTMENTS_PUT_PENDING'
export const DEPARTMENTS_PUT_FULFILLED = 'DEPARTMENTS_PUT_FULFILLED'
export const DEPARTMENTS_PUT_REJECTED = 'DEPARTMENTS_PUT_REJECTED'

export const DEPARTMENTS_DELETE = 'DEPARTMENTS_DELETE'
export const DEPARTMENTS_DELETE_PENDING = 'DEPARTMENTS_DELETE_PENDING'
export const DEPARTMENTS_DELETE_FULFILLED = 'DEPARTMENTS_DELETE_FULFILLED'
export const DEPARTMENTS_DELETE_REJECTED = 'DEPARTMENTS_DELETE_REJECTED'

export const EMPLOYEES_DEPARTMENT_LOAD = 'EMPLOYEES_DEPARTMENT_LOAD'
export const EMPLOYEES_DEPARTMENT_LOAD_PENDING = 'EMPLOYEES_DEPARTMENT_LOAD_PENDING'
export const EMPLOYEES_DEPARTMENT_LOAD_FULFILLED = 'EMPLOYEES_DEPARTMENT_LOAD_FULFILLED'
export const EMPLOYEES_DEPARTMENT_LOAD_REJECTED = 'EMPLOYEES_DEPARTMENT_LOAD_REJECTED'

export const ASSIGN_EMPLOYEES_PUT = 'ASSIGN_EMPLOYEES_PUT'
export const ASSIGN_EMPLOYEES_PUT_PENDING = 'ASSIGN_EMPLOYEES_PUT_PENDING'
export const ASSIGN_EMPLOYEES_PUT_FULFILLED = 'ASSIGN_EMPLOYEES_PUT_FULFILLED'
export const ASSIGN_EMPLOYEES_PUT_REJECTED = 'ASSIGN_EMPLOYEES_PUT_REJECTED'

export const CLONE_PARENT_ORG_DEPARTMENTS = 'CLONE_PARENT_ORG_DEPARTMENTS'
export const CLONE_PARENT_ORG_DEPARTMENTS_PENDING = 'CLONE_PARENT_ORG_DEPARTMENTS_PENDING'
export const CLONE_PARENT_ORG_DEPARTMENTS_FULFILLED = 'CLONE_PARENT_ORG_DEPARTMENTS_FULFILLED'
export const CLONE_PARENT_ORG_DEPARTMENTS_REJECTED = 'CLONE_PARENT_ORG_DEPARTMENTS_REJECTED'
